import { render, staticRenderFns } from "./CapitalAppropriationHistory.vue?vue&type=template&id=c60be230&scoped=true&"
import script from "./CapitalAppropriationHistory.vue?vue&type=script&lang=ts&"
export * from "./CapitalAppropriationHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalAppropriationHistory.vue?vue&type=style&index=0&id=c60be230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60be230",
  null
  
)

export default component.exports